import {
    FETCH_COUNTRY_SHORT_CODE,
    FETCH_COUNTRY_SHORT_CODE_SUCCESS,
    FETCH_COUNTRY_SHORT_CODE_FAILS,
    ASSIGN_COUNTRY_SHORT_CODE,
    FETCH_IPLOCATION_SUCCESS,
    FETCH_IPLOCATION_FAILS,
} from './locationActionTypes';
import { getLocationDetails, getIPLocation } from '../../api/getLocationDetails';
import { getDetailsFromPlaceID, getLatLngfromPlaceId, getLatLngByAddress } from '../../api/getDetailsFromPlaceID';
import { defaultCountry, defaultShortCountryCode, defaultCurrency, COUNTRY_CODES } from '../../components/Common/constants';


// export const getCountryCodes = (lat, long) => {
//   return (dispatch) => {
//     // Dispatch an action to indicate the start of the process
//     dispatch({
//       type: FETCH_COUNTRY_SHORT_CODE,
//     });

//     getLocationDetails(lat, long)
//       .then((res) => {
//         console.log('This is response data duda =======>', res.data)
//         const shortCode = extractShortCode(res.data);

//         //temp
//         let tempCountry = shortCode;
//         if (shortCode === 'AUS') {
//           tempCountry = 'Australia';
//         }

//         const currency = currencyFromCountryCode(shortCode);
//         sessionStorage.setItem('countryShortCode', shortCode);
//         sessionStorage.setItem('currency', currency);
//         dispatch({
//           type: FETCH_COUNTRY_SHORT_CODE_SUCCESS,
//           payload: {
//             country_shortCode: shortCode === 'SG' || shortCode === 'LK' || shortCode === 'AUS' ? shortCode : 'AUS',
//             country_longCode: extractLongCode(res.data),
//             currency: currencyFromCountryCode(shortCode),
//             tempCountry,
//           },
//         });
//       })
//       .catch((error) => {
//         dispatch({
//           type: FETCH_COUNTRY_SHORT_CODE_FAILS,
//           payload: error,
//         });
//       });
//   };
// };

export const getCountryCodes = () => {
    return dispatch => {
        dispatch({ type: FETCH_COUNTRY_SHORT_CODE });

        const { country_shortCode, country_longCode } = COUNTRY_CODES.SRI_LANKA;
        const currency = currencyFromCountryCode(country_shortCode);

        sessionStorage.setItem('countryShortCode', country_shortCode);
        sessionStorage.setItem('currency', currency);

        dispatch({
            type: FETCH_COUNTRY_SHORT_CODE_SUCCESS,
            payload: {
                country_shortCode,
                country_longCode,
                currency,
                tempCountry: country_shortCode
            }
        });
    };
};


export const assignCountryCode = (shortCode, country) => {
    return {
        type: ASSIGN_COUNTRY_SHORT_CODE,
        payload: {
            country_shortCode: shortCode || defaultShortCountryCode,
            country_longCode: country || defaultCountry,
            currency: currencyFromCountryCode(shortCode)
        }
    };
};

export const assignDefaultCountryCode = () => {
    return {
        type: ASSIGN_COUNTRY_SHORT_CODE,
        payload: {
            country_shortCode: defaultShortCountryCode,
            country_longCode: defaultCountry,
            currency: defaultCurrency
        }
    };
};

export const browserLocation = (lat, lng) => {
    const sriLankaCoordinates = {
        lat: 6.901608599999999,  // Sri Lanka Latitude
        lng: 80.0087746 // Sri Lanka Longitude
    };
    return dispatch => {
        sessionStorage.setItem('lat', sriLankaCoordinates?.lat);
        sessionStorage.setItem('lng', sriLankaCoordinates?.lng);
        dispatch({
            type: FETCH_IPLOCATION_SUCCESS,
            payload: {
                location : sriLankaCoordinates
            }
        });
    }
}

// export const getIpLocation = () => {
//             const sriLankaCoordinates = {
//                 location : {
//                     lat: 6.901608599999999,     
//                     lng: 80.0087746 
//                 }
           
//         };
//         return dispatch => {
//         getIPLocation()
//             .then(res => {
//         sessionStorage.setItem('lat', res.data.location.lat);
//         sessionStorage.setItem('lng', res.data.location.lng);
//         dispatch({
//             type: FETCH_IPLOCATION_SUCCESS,
//             payload: res.data
//                 });
//             })
//             .catch(error => {
//                 dispatch({
//                     type: FETCH_IPLOCATION_FAILS,
//                     payload: sriLankaCoordinates
//         });
//     })
//     }
// }

export const getIpLocation = () => {
    return dispatch => {
        // Always use Sri Lanka's coordinates
        const sriLankaCoordinates = {
            lat: 6.901608599999999,     
            lng: 80.0087746 
        };

        // Set the coordinates in sessionStorage
        sessionStorage.setItem('lat', sriLankaCoordinates.lat);
        sessionStorage.setItem('lng', sriLankaCoordinates.lng);

        // Dispatch success with Sri Lanka coordinates
        dispatch({
            type: FETCH_IPLOCATION_SUCCESS,
            payload: {
                location: sriLankaCoordinates
            }
        });
    };
};

const extractShortCode = (result) => {
    if (result.status = 'ok') {
        let locationComponent = result.results.find(res => res.types.includes('country'))
        switch (locationComponent.address_components[0].short_name) {
            case 'LK':
            case 'SG':
                return locationComponent.address_components[0].short_name;
            default:
                return 'AUS';
        }
    }
}

const extractLongCode = (result) => {
    if (result.status = 'ok') {
        let locationComponent = result.results.find(res => res.types.includes('country'))
        switch (locationComponent.address_components[0].long_name) {
            case 'Sri Lanka':
                return 'Sri Lanka'
            case 'Singapore':
                return 'Singapore'
            case 'Australia':
                return 'Australia'
            default:
                return 'Singapore';
        }

    }
}
const currencyFromCountryCode = (countryCode) => {
    switch (countryCode) {
        case 'LK':
            return 'LKR';
        case 'SG':
            return 'SGD'
        case 'AUS':
            return 'AUD'
        default:
            return 'SGD';
    }
}

export const getLocationDetailsOfSelected = placecId => {
    return dispatch => {
        dispatch({
            type: FETCH_COUNTRY_SHORT_CODE
        });
        getDetailsFromPlaceID(placecId).
            then(res => {

                let shortCode = res[0].address_components.find(response => response.types.includes('country')).short_name;
                let longCode = res[0].address_components.find(response => response.types.includes('country')).long_name;
                sessionStorage.setItem('countryShortCode', shortCode);
                sessionStorage.setItem('currency', currencyFromCountryCode(shortCode));

                return {
                    country_shortCode: shortCode || defaultShortCountryCode,
                    country_longCode: longCode || defaultCountry,
                    currency: currencyFromCountryCode(shortCode)
                }
            }).then(res => {
                fetchCountrySortCode(res)
            })

            .catch(error => {
                dispatch({
                    type: FETCH_COUNTRY_SHORT_CODE_FAILS,
                    payload: error
                });
            });
    };
};

export const fetchCountrySortCode = () => {
    return dispatch => {
        // Set Sri Lanka's country short code and currency in sessionStorage
        const sriLankaCountryDetails = {
            country_shortCode: 'LK',
            country_longCode: 'Sri Lanka' // This can be the full country name or code depending on your needs
        };

        sessionStorage.setItem('countryShortCode', sriLankaCountryDetails.country_shortCode);
        sessionStorage.setItem('currency', currencyFromCountryCode(sriLankaCountryDetails.country_shortCode));

        // Use Sri Lanka's fixed latitude and longitude
        const sriLankaCoordinates = {
            lat: 6.901608599999999, // Sri Lanka latitude
            lng: 80.0087746  // Sri Lanka Longitude
        };

        // Dispatch the browserLocation action with Sri Lanka's coordinates
        dispatch(browserLocation(sriLankaCoordinates.lat, sriLankaCoordinates.lng));

        // Dispatch the success action with Sri Lanka's details
        dispatch({
            type: FETCH_COUNTRY_SHORT_CODE_SUCCESS,
            payload: sriLankaCountryDetails
        });
    };
};


export const getSuggestions = (lat, lng, country) => {
    return (dispatch, getState, { axiosInstance }) => {
        sessionStorage.setItem('currency', currencyFromCountryCode(country));
        if(lat && lng){
            dispatch(browserLocation(lat, lng));
        }else{
            for(let details in COUNTRY_CODES){
                if(COUNTRY_CODES[details].country_shortCode === country) {
                    const {lat, lng } = COUNTRY_CODES[details]
                    dispatch(browserLocation(lat, lng));
                }
                
            }
        }   
    }
}

export const getLatLngByPlaceId = (placeId) => {
    return dispatch => {
        getLatLngfromPlaceId(placeId)
            .then((res) => {
                dispatch(browserLocation(res.lat, res.lng));
            })

    }
}